/* 
 *  This file log-errors.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022  
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NewRelicService } from '../newrelic-handler/newrelic.service';
@Injectable()
export class LogErrorsService {

    constructor(private newRelicService: NewRelicService) {}

    logError(error: any): void {
        console.error('log error ', error);

        if (this.newRelicService.isReady() && !(error instanceof HttpErrorResponse)) {
            const errorDetails = this.extractErrorDetails(error);
            const errorToReport = new Error(error.message || 'Unknown Error');
            errorToReport.name = errorDetails.errorType;
            errorToReport.stack = error.stack || new Error().stack;
            this.newRelicService.noticeError(errorToReport, errorDetails);
        }
    }

    private extractErrorDetails(error: any): Record<string, any> {
        const details: Record<string, any> = {
            source: 'LogErrorsService',
            timestamp: new Date().toISOString(),
            userAgent: navigator.userAgent,
            pageUrl: window.location.href,
            errorType: 'UnknownError'
        };

        if (error instanceof Error) {
            details.errorType = 'JavaScriptError';
            details.errorName = error.name;
            details.errorMessage = error.message;
            details.stackTrace = error.originalStack || error.stack || 'No stack trace';
        } else if (typeof error === 'string') {
            details.errorType = 'StringError';
            details.errorMessage = error;
        } else if (error && typeof error === 'object') {
            details.errorType = 'ObjectError';
            details.errorMessage = JSON.stringify(error).substring(0, 500);
        }

        return details;
    }
}
